/**
 * Toggle Switch Module
 * 
 * @package KateMedia
 */

export function initToggleSwitch() {
    const toggleSwitches = document.querySelectorAll('.efficiency__toggle-switch');
    
    if (toggleSwitches.length === 0) {
        return;
    }
    
    toggleSwitches.forEach(toggle => {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            this.classList.toggle('efficiency__toggle-switch--active');
        });
    });
}
